import React, { useEffect, useMemo, useRef, useState } from 'react';
import { calculateRemainingSeconds, formatDuration } from '../utils/timer';

const CountdownTimer = ({ timer, onExpire, intervalMs = 1000 }) => {
  const [remaining, setRemaining] = useState(() => calculateRemainingSeconds(timer));
  const latestTimerRef = useRef(timer);

  useEffect(() => {
    latestTimerRef.current = timer;
    setRemaining(calculateRemainingSeconds(timer));
  }, [timer]);

  useEffect(() => {
    const tick = () => {
      setRemaining((prev) => {
        if (prev === null) {
          return null;
        }
        const next = Math.max(0, prev - 1);
        if (next === 0 && prev !== 0 && typeof onExpire === 'function') {
          onExpire();
        }
        return next;
      });
    };

    const id = setInterval(tick, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, onExpire]);

  useEffect(() => {
    if (!latestTimerRef.current) {
      return;
    }
    const id = setInterval(() => {
      const recalculated = calculateRemainingSeconds(latestTimerRef.current);
      setRemaining((current) => {
        if (current === null) {
          return recalculated;
        }
        return Math.min(current, recalculated ?? current);
      });
    // }, Math.max(intervalMs * 10, 5000));
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  const display = useMemo(() => formatDuration(remaining), [remaining]);

  return <span>{display}</span>;
};

export default CountdownTimer;
